<template>
  <div class="layout-default" :class="{ 'has-gnb': showGnb }" data-layout="default">
    <HeaderComponent v-if="showHeader" />
    <main id="content">
      <AppHeader
        v-if="showAppHeader"
        :title="appHeaderTitle"
        :back-to="appHeaderBackTo"
        :action-label="appHeaderAction"
        :hide-back="hideAppHeaderBack"
        @action="onHeaderAction"
      />
      <slot />
    </main>
    <GnbComponent v-if="showGnb" />
  </div>
</template>

<script setup>
// 앱 스타일. 홈페이지(layouts/homepage.vue)에는 로드되지 않도록 전역(nuxt.config css)이 아닌 레이아웃에서 불러온다.
import "~/assets/css/style.css";
import "~/assets/scss/style.scss";
import AppHeader from "../components/AppHeader.vue";
import GnbComponent from "./GnbComponent.vue";
import HeaderComponent from "./HeaderComponent.vue";

const route = useRoute();

const GNB_PREFIXES = ["/main", "/mypage", "/magazine", "/device", "/family"];

const JOIN_APP_HEADER_PATHS = ["/join/permission", "/join/accessibility-guide", "/join/verify", "/join/captcha", "/join/plan", "/join/terms"];
const DEVICE_APP_HEADER_PATHS = ["/device/block-apps", "/device/lock-message", "/device/emergency-contact", "/device/location", "/device/siren", "/device/loss-status", "/device/usim-history", "/device/message-history"];
const isDeviceAppHeaderPage = computed(() =>
  DEVICE_APP_HEADER_PATHS.some((path) => route.path === path || route.path.startsWith(`${path}/`))
);
const showAppHeader = computed(() => {
  if (route.meta.appHeader) return true;
  if (isDeviceAppHeaderPage.value) return true;
  return JOIN_APP_HEADER_PATHS.some((path) => route.path === path || route.path.startsWith(`${path}/`));
});
const showHeader = computed(() => {
  if (route.path === "/main" || route.path.startsWith("/main/")) return false;
  return !route.meta.hideHeader && !showAppHeader.value;
});
const pinResetFlow = usePinResetFlow();
const isPinResetAuthPage = computed(() => {
  const path = appPath(route.path);
  return (
    (path === "/join/verify" || path === "/join/captcha") &&
    String(route.query.mode || "") === "pin-reset"
  );
});
const appHeaderTitle = computed(() => route.meta.title || "");
const appHeaderBackTo = computed(() => {
  if (isPinResetAuthPage.value) {
    const path = appPath(route.path);
    const from =
      String(route.query.from || "") === "guest" || pinResetFlow.read().from === "guest"
        ? "guest"
        : "host";
    if (path === "/join/captcha") {
      return `/join/verify?mode=pin-reset&from=${from}`;
    }
    return pinResetFlow.unlockPinPath(from);
  }
  return route.meta.backTo || "/device";
});
const appHeaderAction = computed(() => route.meta.headerAction || "");
const hideAppHeaderBack = computed(
  () =>
    Boolean(route.meta.hideBack) ||
    (((route.path === "/join/permission" ||
      route.path === "/guest/permission" ||
      route.path === "/join/accessibility-guide" ||
      route.path === "/guest/accessibility-guide") &&
      String(route.query.mode || "") === "required")),
);

const onHeaderAction = () => {
  const to = route.meta.headerActionTo;
  if (to) navigateTo(to);
};

const showGnb = computed(() => {
  if (route.meta.hideGnb) return false;
  if (isDeviceAppHeaderPage.value) return false;
  if (route.meta.showGnb) return true;
  return GNB_PREFIXES.some((path) => route.path === path || route.path.startsWith(`${path}/`));
});

console.log("default layout is rendering");
</script>
